import { render } from "./AnnotationsCanvas.vue?vue&type=template&id=2fdc8fd0"
import script from "./AnnotationsCanvas.vue?vue&type=script&lang=js"
export * from "./AnnotationsCanvas.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jjviglio/OpenMCT/openmct/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__